import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule, BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { TimeToDateModule } from '../../../shared';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    TooltipModule.forRoot(), BsDatepickerModule.forRoot(), TimepickerModule.forRoot(),
    TimeToDateModule
  ],
  declarations: [HeaderComponent],
  exports:[HeaderComponent] 
})
export class HeaderModule { }
